<template>
  <li :class="cls">
    <a :href="href">
      <span class="title">{{ title }}</span>
      <span class=" arrow"></span>
    </a>
    <span :class="iconClass()"><i :class="icon"></i></span>
    <ul class="sub-menu">
      <slot></slot>
    </ul>
</li>
</template>

<script>
  export default {
    name: "SidePanelCollection",
    props: {
      href: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: 'Item'
      },
      details: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: 'pg-form'
      },
      active: {
        type: Boolean,
        default: false
      },
      cls: {
        type: String,
        default: ''
      }
    },
    methods: {
      iconClass() {
        return this.active ? 'bg-success icon-thumbnail' : 'icon-thumbnail';
      }
    }
  }
</script>

<style scoped>
    

</style>


// WEBPACK FOOTER //
// side_panel_collection.vue?ea91eb70